// extracted by mini-css-extract-plugin
export default {"gallery-link":"FooterGallery_gallery-link__G+NQZ"};